/**
 * Settings > Notifications > Pokes: the buzz's own switch (it covers the
 * vibration on phones), its volume and a preview. Kept on this device, like
 * Settings > Sounds.
 */
import { useT } from '../i18n';
import { SetGroup, SetRow } from '../settings/Settings';
import { IconBtn, Range, Switch } from '../ui/kit';
import { playBuzz, usePokeAlert } from './alert';

export function PokeAlertSettings() {
  const { t, fmt } = useT();
  const prefs = usePokeAlert((s) => s.prefs);
  const setPrefs = usePokeAlert((s) => s.setPrefs);
  const pct = fmt.num(prefs.volume, { style: 'percent', maximumFractionDigits: 0 });
  return (
    <SetGroup title={t('pk.set.group')}>
      <SetRow label={t('pk.set.buzz')} sub={t('pk.set.buzzSub')}>
        <IconBtn
          icon="play"
          label={t('pk.set.preview')}
          onClick={() => playBuzz({ preview: true })}
        />
        <Switch
          checked={prefs.buzz}
          label={t('pk.set.buzz')}
          onChange={(v) => setPrefs({ buzz: v })}
        />
      </SetRow>
      <SetRow label={t('pk.set.volume')}>
        <Range
          min={0}
          max={100}
          step={5}
          value={Math.round(prefs.volume * 100)}
          disabled={!prefs.buzz}
          aria-label={t('pk.set.volume')}
          aria-valuetext={pct}
          onChange={(e) => setPrefs({ volume: Number(e.target.value) / 100 })}
          onPointerUp={() => playBuzz({ preview: true })}
        />
        <span className="nx-num ns-range-v">{pct}</span>
      </SetRow>
    </SetGroup>
  );
}
